<template>
  <div>
    <div class="Dcontent-warpper">
      <div class="Dcontent alitypes">
        <el-checkbox-group v-model="selected"
          size="small">
          <el-checkbox v-for="item in typeList"
            :key="item.id"
            :label="item.name"
            border></el-checkbox>
        </el-checkbox-group>
      </div>
    </div>
    <div class="Dbottom-btns">
      <el-button size="medium"
        @click="cancel">取消</el-button>
      <el-button size="medium"
        type="primary"
        @click="submit">确认</el-button>
    </div>
  </div>
</template>
<script>
import { aliCateByLocal } from '@/api/goods'
export default {
  props: ['visible', 'selectedTypes', 'type', 'pid'],
  data () {
    return {
      selected: [],
      typeList: []
    }
  },
  watch: {
    visible (newValue) {
      if (newValue) {
        this.getList()
        const arr = []
        this.selectedTypes.forEach(sitem => {
          arr.push(sitem.name)
        })
        this.selected = arr
      }
    }
  },
  mounted () {

  },
  methods: {
    getList () {
      var form
      if (this.type === '2') {
        form = {
          parent_id: this.pid
        }
      } else {
        form = {
          parent_id: this.pid
        }
      }
      aliCateByLocal(form).then(res => {


        if (this.type == 2) {
          var arr = []
          res.map(itemArr => {
            if (itemArr) {
              arr = arr.concat(itemArr)
            }

          })

          this.typeList = arr
          console.log(this.typeList)
        } else {
          this.typeList = res
        }

      })
    },
    cancel () {
      this.$emit('close')
    },
    submit () {
      let arr = []
      const { typeList, selected } = this
      selected.forEach(name => {
        typeList.forEach(item => {
          if (name === item.name) {
            arr.push(item)
          }
        })
      })
      this.$emit('getSelected', arr)
    }
  }
}
</script>
<style lang="scss">
.alitypes {
	.el-checkbox {
		margin-bottom: 12px;
		margin-right: 12px;
		margin-left: 0;
	}
	.el-checkbox.is-bordered + .el-checkbox.is-bordered {
		margin-right: 12px;
		margin-left: 0;
	}
}
</style>
